import React, { ReactNode } from 'react';

import Header from '../Header';
import Sidebar from '../Sidebar';
import SubHeader from './SubHeader';
import Body from './Body';
import { LayoutProvider } from '../../contexts/LayoutContext';

type Props = {
  children?: ReactNode;
  breadCrumbs?: ReactNode;
  name?: string;
};

const DashboardLayout = ({ children, breadCrumbs, name }: Props) => {
  return (
    <LayoutProvider>
      <div>
        <Header />
        <SubHeader breadCrumbs={breadCrumbs} />
        <Sidebar active={name} />
        <Body>{children}</Body>
      </div>
    </LayoutProvider>
  );
};

export default DashboardLayout;
